import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "space-evenly",
        flexDirection: "row"
    },
    timerBox: {
        alignItems: "center"
    }
});
export default stylesheet;
